import React from "react";
import {
  FaEye,
  FaFilePdf,
  FaBook,
  FaFile,
  FaClipboardList,
} from "react-icons/fa";
import { Card } from "../UI/DesignStandards/Cards";
import { IconButton } from "../UI/DesignStandards/Buttons";

const DOCUMENT_TYPE_ICONS = {
  flyer: FaFilePdf,
  rules: FaBook,
  entry_form: FaClipboardList,
  other: FaFile,
};

const TournamentDocumentsSidebar = ({ documents, onDocumentClick }) => {
  const getDocumentIcon = (documentType) => {
    return DOCUMENT_TYPE_ICONS[documentType] || FaFile;
  };

  return (
    <Card>
      <h2 className="heading-display text-xl mb-1">Documents</h2>
      <div className="divide-y divide-brand-charcoal/10">
        {documents && documents.length > 0 ? (
          documents.map((document) => {
            const IconComponent = getDocumentIcon(document.documentType);
            return (
              <div
                key={document.id}
                className="flex items-center gap-2 py-3 min-w-0"
              >
                <button
                  onClick={() => onDocumentClick(document.url, document.title)}
                  className="flex items-center min-w-0 flex-1 overflow-hidden text-left hover:text-brand-charcoal focus:outline-none focus:ring-2 focus:ring-brand-gold-ink focus:ring-inset rounded-lg"
                >
                  <IconComponent className="mr-3 text-brand-muted flex-shrink-0" />
                  <div className="min-w-0 flex-1 overflow-hidden">
                    <div className="font-medium truncate">{document.title}</div>
                    <div className="text-sm text-brand-muted truncate">
                      {document.description || document.documentType}
                    </div>
                  </div>
                </button>
                <IconButton
                  onClick={() => onDocumentClick(document.url, document.title)}
                  icon={FaEye}
                  variant="secondary"
                  size="sm"
                  className="bg-transparent text-brand-muted hover:text-brand-charcoal hover:bg-brand-charcoal/5 ml-0 flex-shrink-0"
                  title={`View ${document.title}`}
                  aria-label={`View ${document.title}`}
                />
              </div>
            );
          })
        ) : (
          <p className="text-brand-muted italic text-sm py-3">
            No documents available.
          </p>
        )}
      </div>
    </Card>
  );
};

export default TournamentDocumentsSidebar;
